'use es6';

import { fromJS } from 'immutable';
import sortBy from 'transmute/sortBy';
import getIn from 'transmute/getIn';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { CONTACTS } from 'reporting-data/constants/dataTypes';
const getFilters = getIn(['config', 'filters']);

// showTotals is not used in the display functionality, but is needed in the resolve
// to get the summary dataset which will be needed to display the percentages
const getDisplayParams = report => report.get('displayParams').set('showTotals', true);
const getPersonaSum = getIn(['SUM|count']);
const getPersonaProperties = getIn(['primary', 'data', 'properties', 'hs_persona', 'references']);
export const getPersonaAggregation = report => {
  return fromJS({
    chartType: TABLE,
    displayParams: getDisplayParams(report),
    config: {
      configType: AGGREGATION,
      dataType: CONTACTS,
      filters: getFilters(report),
      dimensions: ['hs_persona'],
      sort: [],
      metrics: [{
        property: 'count',
        metricTypes: ['SUM']
      }]
    }
  });
};
export const getTableRows = (data, personas) => {
  const primaryData = data.getIn(['primary', 'data', 'data']);
  const missingPoint = primaryData.find(dataObj => dataObj.get('hs_persona') === '@@MISSING@@');
  const tableData = sortBy(getIn(['count']), [...(missingPoint ? [{
    personaLabel: getPersonaProperties(data).getIn(['@@MISSING@@', 'label']),
    personaId: '@@MISSING@@',
    count: getPersonaSum(missingPoint)
  }] : []), ...personas.map(({
    id,
    label
  }) => {
    const matchingPersona = primaryData.find(b => b.get('hs_persona') === id);
    return {
      personaLabel: matchingPersona != null ? getPersonaProperties(data).getIn([id, 'label']) : label,
      personaId: id,
      count: matchingPersona != null ? getPersonaSum(matchingPersona) : 0
    };
  })]).reverse();
  return tableData;
};